import './DummyHeader.css'

import { IonHeader, IonToolbar } from '@ionic/react'
// this is to create a space between the top of screen and the content of the app
export default function DummyHeader() {
  return (
    <IonHeader className="ion-no-border dummy-header">
      <IonToolbar />
    </IonHeader>
  )
}
